import { Pipe, PipeTransform } from '@angular/core';

import { isUndefined, isNull } from '@fcom/core/utils/utils';

export const NBSP = '\u00A0';

@Pipe({
  name: 'finEmpty',
  standalone: false,
})
export class EmptyPipe implements PipeTransform {
  transform(input: string, replaceWith: unknown = NBSP): string {
    if (isUndefined(input) || isNull(input) || input === '') {
      return replaceWith as string;
    }
    return input;
  }
}
